import script from "./OtherProductOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherProductOptions.vue?vue&type=script&setup=true&lang=js"

import "./OtherProductOptions.vue?vue&type=style&index=0&id=4ef5f994&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef5f994"]])

export default __exports__